import styles from "../../Dashboard.module.css";
import { grantStatus } from "../../../../../utils/Enums/grantStatus";

const CalendarDetailsPanel = ({ selectedDay, selectedRegistro }) => {
    return (
        <>
            <h3>
                {selectedDay && `Dia ${selectedDay}`}
                {(selectedRegistro?.status === 6 || selectedRegistro?.status === 7) ?
                    " - " + grantStatus[selectedRegistro?.status] : ""
                }
            </h3>

            {selectedRegistro && (
                <span>{selectedRegistro.periodoDescricao}</span>
            )}

            {(!selectedRegistro?.violacoes?.length) ? (
                <>
                    <span>{selectedDay && "Todos os parâmetros dentro do limite"}</span>

                    <div
                        style={{
                            marginTop: selectedDay ? 40 : 100,
                            textAlign: "center",
                            fontSize: 16,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        {!(selectedRegistro?.status === 6 || selectedRegistro?.status === 7) && (
                            <>
                                <i className={`fa ${selectedDay ? 'fa-calendar-check' : 'fa-calendar'} fa-30px`} />
                                <strong>{selectedDay ? "Nenhuma violação neste dia" : "Selecione um dia"}</strong>
                            </>
                        )}

                    </div>

                    {!selectedDay && (
                        <div
                            style={{
                                marginTop: 10,
                                textAlign: "center",
                            }}
                        >
                            <span>Clique em um dia do calendário para ver os detalhes dos parâmetros</span>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <span>{selectedRegistro?.violacoes?.length} parâmetro(s) excedido(s)</span>

                    <div className={styles.calendarDetailsList}>
                        {selectedRegistro?.violacoes?.map(
                            (violacao, i) =>
                                violacao?.excedidoFim && (
                                    <div key={i} className={styles.calendarDetailCard}>
                                        <div className={styles.calendarDetailHeader}>
                                            <span>{violacao.descricao}</span>
                                            <span className={styles.calendarExceeded}>Excedido</span>
                                        </div>

                                        <div
                                            className={styles.progressBarCalendar}
                                            style={{ width: `${Math.min(violacao.percentual, 100)}%` }}
                                        />

                                        <div className={styles.calendarDetailFooter}>
                                            <span>
                                                Excedido: {`${violacao?.excedidoInicio} até ${violacao?.excedidoFim}`}
                                                {violacao.unidade}
                                            </span>
                                            <span>
                                                {violacao.excedente}{" "}
                                                {violacao.unidade} acima
                                            </span>
                                        </div>

                                        <strong>
                                            Registrado:{" "}
                                            {violacao.registrado}{" "}
                                            {violacao.unidade}
                                        </strong>
                                    </div>
                                )
                        )}
                    </div>
                </>
            )}
        </>
    );
}

export default CalendarDetailsPanel;